export class PbbDocumentos {

    static pbbDocumentosLista: PbbDocumentos[] = [
        { tipo: 'pdf', descricao: 'Relatório da Oper Utilização dos Fundos Previdenciais de 2024', caminho: 'Relat_Oper_Utiliz_Fund_Previd_2024_pbb.pdf' },
        { tipo: 'pdf', descricao: 'Relatório de Oper Utilização dos Fundos Previdenciais de 2023', caminho: 'Relatorio_Oper_Utiliz_Fundos_Previdenciais_2023.pdf' },
        { tipo: 'pdf', descricao: 'Plano de Destinação e Utilização da Reserva Especial – 2019', caminho: 'PlanoDestinacaoUtilizacaoReservaEspecial_2019.pdf' },
        { tipo: 'pdf', descricao: 'Plano de Destinação e Utilização da Reserva Especial – 2018', caminho: 'PlanoDestinacaoUtilizacaoReservaEspecial_2018.pdf' },
        { tipo: 'pdf', descricao: 'PBB - Destinação Superavit  2017', caminho: 'Superavit_PBB_2017_Regulamento.pdf' },
        { tipo: 'pdf', descricao: 'PBB - Destinação Superavit  2016', caminho: 'pbb_destinacao_reserva_especial_2016.pdf' },
        { tipo: 'pdf', descricao: 'PBB - Destinação Superavit  2015', caminho: 'pbb_destinacao_reserva_especial_2015.pdf' },
        { tipo: 'pdf', descricao: 'PBB - Destinação Superavit  2014', caminho: 'pbb_destinacao_reserva_especial_2014.pdf' },
        { tipo: 'pdf', descricao: 'Destinação e Utilização da Reserva Especial - 2012', caminho: 'DESTINACAO_PBB_2016.pdf' },

    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {
    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/pbb-documentos.ts